import React from "react";
import "../css/Confirmacion.css"
import { TextField, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";


export default function Confirmacion(props) {

    return (
        <Dialog open={props.open} fullWidth>

            <DialogTitle color="coopinfa">Confirmación</DialogTitle>
            <DialogContent>
                <div className="Conf-texto">
                    {props.texto}
                </div>

            </DialogContent>
            <DialogActions>
                <Button color="coopinfa" onClick={() => { props.cancelar() }}>Cancelar</Button>
                <Button color="coopinfa" onClick={() => { props.exito() }}>Ok</Button>
            </DialogActions>
        </Dialog>
    )
}